// extracted by mini-css-extract-plugin
module.exports = {"shadowed":"Blog_shadowed__34WnT","block":"Blog_block__20Vd-","image":"Blog_image__2ephW","source":"Blog_source__3pgTl"};